module.exports = __webpack_public_path__ + "img/06186733000220.8619fd3c.png";